import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsReadSome, IDB_rowsWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { Type_Workflow } from '../Type/Type.hive'
import type { ClientLogger } from '../../../shared/lib/ClientLogger.no-deps'

export function IDB_workflowRead(id: number) {
    return IDB_rowRead<Type_Workflow>(IDB_globalDb, 'activities', id)
}

export function IDB_workflowsDelete(logger: ClientLogger, ids: number[]) {
    logger.log(`deleting workflows`, { workflowIds: ids })
    return IDB_rowsDelete(IDB_globalDb, 'activities', ids)
}

export function IDB_workflowsReadAll() {
    return IDB_rowsReadAll<Type_Workflow>(IDB_globalDb, 'activities')
}

export function IDB_workflowReadSome(ids: number[]) {
    return IDB_rowsReadSome<Type_Workflow>(IDB_globalDb, 'activities', ids)
}

export function IDB_workflowsWrite(logger: ClientLogger, workflows: Type_Workflow[]) {
    logger.log(`writing workflows`, { workflowIds: workflows.map((a) => a.id) })
    return IDB_rowsWrite(IDB_globalDb, 'activities', workflows)
}
